import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import _ from '../../../../@lodash';

const cyclesAdapter = createEntityAdapter({});

export const {
  selectAll: selectCycles,
  selectIds: selectCycleIds,
  selectById: selectCycleById,
} = cyclesAdapter.getSelectors((state) => state.reviews.cycles);

const cyclesSlice = createSlice({
  name: 'cycles',
  initialState: cyclesAdapter.getInitialState({
    ids: ['dev_alpha_internal', 'dev_alpha', 'dev_alpha_revision', 'dev_beta', 'dev_beta_revision', 'dev_final', 'prod_alpha_internal', 'prod_alpha', 'prod_alpha_revision', 'prod_beta', 'prod_beta_revision', 'prod_final'],
    entities: [
      { title: 'SB ALPHA Development', color: '#FF55BF', id: 'dev_alpha_internal' },
      { title: 'SB ALPHA Review', color: '#80F2E7', id: 'dev_alpha' },
      { title: 'SB ALPHA Revision', color: '#FF55BF', id: 'dev_alpha_revision' },
      { title: 'SB BETA Review', color: '#48BF91', id: 'dev_beta' },
      { title: 'SB BETA Revision', color: '#FF55BF', id: 'dev_beta_revision' },
      { title: 'SB Final Review and Acceptance', color: '#013BB1', id: 'dev_final' },
      { title: 'IMI ALPHA Development', color: '#8A2FFF', id: 'prod_alpha_internal' },
      { title: 'IMI ALPHA Review', color: '#80F2E7', id: 'prod_alpha' },
      { title: 'IMI ALPHA Revision', color: '#8A2FFF', id: 'prod_alpha_revision' },
      { title: 'IMI BETA Review', color: '#48BF91', id: 'prod_beta' },
      { title: 'IMI BETA Revision', color: '#8A2FFF', id: 'prod_beta_revision' },
      { title: 'IMI Final Review and Acceptance', color: '#013BB1', id: 'prod_final' },
      { title: 'Pre-Trials QA', color: '#FF5454', id: 'trials_pre' },
      { title: 'Individual Trials Review', color: '#80F2E7', id: 'trials_individual' },
      { title: 'Individual Trials Revision', color: '#FF5454', id: 'trials_individual_revision' },
      { title: 'Group Trials Review', color: '#80F2E7', id: 'trials_group' },
      { title: 'Group Trials Revision', color: '#FF5454', id: 'trials_group_revision' },
      { title: 'Trials Final Review and Acceptance', color: '#013BB1', id: 'trials_final' },
    ],
    selectedCycles: ['dev_alpha_internal', 'dev_alpha', 'dev_alpha_revision', 'dev_beta', 'dev_beta_revision', 'dev_final', 'prod_alpha_internal', 'prod_alpha', 'prod_alpha_revision', 'prod_beta', 'prod_beta_revision', 'prod_final', 'trials_pre', 'trials_individual', 'trials_individual_revision', 'trials_group', 'trials_group_revision', 'trials_final'],
  }),
  reducers: {
    toggleSelectedCycles: (state, action) => {
      state.selectedCycles = _.xor(state.selectedCycles, [action.payload]);
    },
  },
});

export const selectSelectedCycles = ({ reviews }) => reviews.cycles.selectedCycles;
export const selectFirstCycleId = ({ reviews }) => reviews.cycles.ids[0];

export const { toggleSelectedCycles } = cyclesSlice.actions;

export default cyclesSlice.reducer;
